








// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { getDefaultAloPiscine, AloPiscine } from '@/models/alo/AloPiscine';
import { toStringDictionary } from '@/utils/groupBy';

@Component({
  name: 'EditBasePiscine',    
  components:{EditDrawer}, 
  props: {
    title:String,            
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    }
  } 
})
export default class EditBasePiscine extends Vue {
  
  private original:AloPiscine = getDefaultAloPiscine()
  private modified:AloPiscine = getDefaultAloPiscine()
  private showDrawer = false
  private saving = false
    
  edit(item:AloPiscine) {
    this.$store.myActions.ADM_PISCINE_RESET_STATUS()
    this.showDrawer = true
    this.original = {...getDefaultAloPiscine(),...item}    
    this.modified = cloneDeep(this.original)
    
    return this.modified
  }
  
  get configuration(){
    return this.$store.myGetters.configuration
  }

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get piscineStatus() {
    return this.$store.myGetters.piscineStatus        
  }

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      this.$store.myActions.ADM_PISCINE_SAVE_REQUEST(this.modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.piscineStatus)          
        this.showDrawer = false
      }).finally(()=>{
        this.saving = false
      })    
    } 
  }

}
